import { ROUTE_HOMEPAGE, ROUTE_UPLOAD_FIRST_BILL } from '@1bill-app/constants';
import { BillQuery } from '@1bill-app/services/bill/bill.query';
import { BillService } from '@1bill-app/services/bill/bill.service';
import { RewardQuery } from '@1bill-app/services/reward/reward.query';
import { RewardService } from '@1bill-app/services/reward/reward.service';
import { Reward, RewardActionCodeMapping } from '@1bill-app/services/reward/reward.type';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import ConfettiGenerator from 'confetti-js';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-post-mobile-verification',
  templateUrl: './post-mobile-verification.page.html',
  styleUrls: ['./post-mobile-verification.page.scss'],
})
export class PostMobileVerificationPage implements OnInit, OnDestroy {
  subs = new SubSink();
  profileReward: Reward[];
  routeUploadBill = ROUTE_UPLOAD_FIRST_BILL;
  routeHome = ROUTE_HOMEPAGE;
  userUploadedBill$ = this.billQuery.hasUserUploadedBills();
  confettiPosition = 'fixed';
  isLoading$ = this.rewardQuery.isLoading$;
  referralEligibility = false;

  verifyMobileRewardPoint$ = this.rewardQuery.getProfileRewardPoint(
    RewardActionCodeMapping.VERIFY_MOBILE_NUMBER,
  );
  addFirstBillPoint$ = this.rewardQuery.getProfileRewardPoint(
    RewardActionCodeMapping.ADD_FIRST_BILL,
  );
  totalProfilePoint$ = this.rewardQuery.getProfileRewardPoint(
    RewardActionCodeMapping.COMPLETE_PROFILE,
  );

  constructor(
    private navCtrl: NavController,
    public rewardQuery: RewardQuery,
    public rewardService: RewardService,
    public billQuery: BillQuery,
    public billService: BillService,
  ) {}

  ngOnInit() {
    this.explodeConfetti();
    this.subs.sink = this.billService.getBill().subscribe();
    this.subs.sink = this.rewardQuery.getRewardsCache().subscribe();
    // HIDEREFERRALCODES
    // this.subs.sink = this.rewardService.getReferralCodeEligiblity().subscribe((response) => {
    //   this.referralEligibility = response;
    //   if (this.referralEligibility) {
    //     // User received 1,000 1Bill points for referral code after verifying their mobile number.
    //     // Update reward points in app with this API call.
    //     this.rewardService.getRewards().subscribe();
    //   }
    // });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  explodeConfetti() {
    const confettiSettings = {
      target: 'confetti-canvas',
      max: 300,
      respawn: false,
      size: 1.2,
    };
    const confetti = new ConfettiGenerator(confettiSettings);
    confetti.render();
    setTimeout(
      function () {
        confetti.clear();
        this.confettiPosition = 'absolute';
      }.bind(this),
      6000,
    );
  }

  onClickSkip() {
    this.navCtrl.navigateForward([ROUTE_HOMEPAGE]);
  }
}
